// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"TableCheckBox_checkboxWrapper__hNauU"};